exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-lg{\r\n    font-size: 100px;\r\n}\r\n\r\n.loading-md{\r\n    font-size: 50px;\r\n}\r\n\r\n.loading-sm{\r\n    font-size: 25px;\r\n}\r\n\r\n.loading-spinner{\r\n    text-align: center;\r\n}\r\n\r\n@media screen and (max-width: 768px){\r\n    .loading-sm,.loading-md,.loading-lg{\r\n        font-size: 16px !important;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/components/loading/loading.component.css
// module id = ../../../../../src/app/Modules/Shared/components/loading/loading.component.css
// module chunks = main